import { render } from "./role-form.vue?vue&type=template&id=38a52962"
import script from "./role-form.vue?vue&type=script&lang=js"
export * from "./role-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__